import React, { useEffect } from "react";
import { FiX, FiCheckCircle } from "react-icons/fi";
import "../../../views/app/productCategories/AddProductCategoryModal.scss";
import "./modals.scss";

interface SuccessModalProps {
  show: boolean;
  onHide: () => void;
  title: string;
  message: string;
  autoClose?: boolean;
  autoCloseDelay?: number;
  actionText?: string;
  onAction?: () => void;
}

export const SuccessModal: React.FC<SuccessModalProps> = ({
  show,
  onHide,
  title,
  message,
  autoClose = true,
  autoCloseDelay = 3000,
  actionText = "OK",
  onAction,
}) => {
  useEffect(() => {
    if (show && autoClose) {
      const timer = setTimeout(() => {
        onHide();
      }, autoCloseDelay);

      return () => clearTimeout(timer);
    }
  }, [show, autoClose, autoCloseDelay, onHide]);

  const handleAction = () => {
    if (onAction) {
      onAction();
    }
    onHide();
  };

  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <FiCheckCircle size={24} color="#00A759" />
            <h2>{title}</h2>
          </div>
          <FiX className="close-icon" onClick={onHide} />
        </div>
        <div className="modal-form">
          <p
            style={{
              fontSize: "14px",
              color: "#605E5E",
              marginBottom: "1.5rem",
            }}
          >
            {message}
          </p>
          <button
            type="button"
            className="submit-btn"
            onClick={handleAction}
            style={{ backgroundColor: "#00A759" }}
          >
            {actionText}
          </button>
        </div>
      </div>
    </div>
  );
};
